import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=5bc5ea9a&lang=scss"
import "./App.vue?vue&type=style&index=1&id=5bc5ea9a&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=2&id=5bc5ea9a&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bc5ea9a"]])

export default __exports__